import React, { useEffect, useState } from "react";
import { debug } from "../../utils";
import { connect } from "react-redux";
import * as validationService from "../add-device-modal/validationService";

function SshPasswordlessKeyField({ value, anotherSectionActive, onChange, passwordChanged, onChangePasswordClick, centralCredentialId, error, disabled }) {

    const [disableInput, setDisableInput] = useState(true)
    const [showChangeBtn, setShowChangeBtn] = useState(true) 

    const ProcessData = async () => {
        if (anotherSectionActive) {
            validationService.cleanValidation('sshPasswordlessKey');
            //onChange('');
        } 
        else if (centralCredentialId && centralCredentialId > 0) {
            validationService.cleanValidation('sshPasswordlessKey');            
            setShowChangeBtn(false);
            setDisableInput(true);
            //onChange('');
        } 
        else {
            validationService.validateNotEmpty(value, 'sshPasswordlessKey');
            if (passwordChanged && showChangeBtn && disableInput) {
                setShowChangeBtn(true);
                setDisableInput(false);
            } 
            else if (passwordChanged && showChangeBtn && !disableInput) {
                setShowChangeBtn(false);
                setDisableInput(false);
            } 
            else if (passwordChanged && !showChangeBtn && disableInput) {
                setShowChangeBtn(false);
                setDisableInput(false);
            }
            else if (passwordChanged && !showChangeBtn && !disableInput) {
                setShowChangeBtn(false);
                setDisableInput(false);
            }  
            

            else if (!passwordChanged && !showChangeBtn && !disableInput) {
                setShowChangeBtn(false);
                setDisableInput(false);
            } 
            else if (!passwordChanged && !showChangeBtn && disableInput) {
                setShowChangeBtn(false);
                setDisableInput(false);
            }
            else if (!passwordChanged && showChangeBtn && disableInput) {
                setShowChangeBtn(true);
                setDisableInput(true);
            } 
             
            else {
                setDisableInput(true); 
            }         
        }
        return () => validationService.cleanValidation('sshPasswordlessKey');
    }
    
    useEffect(() => {
        ProcessData();
        /* eslint-disable react-hooks/exhaustive-deps */
      
    }, [value, anotherSectionActive, centralCredentialId])

    // useEffect(() => {
    //     if (anotherSectionActive) {
    //         validationService.cleanValidation('sshPasswordlessKey');
    //     } else {
    //         validationService.validateNotEmpty(value, 'sshPasswordlessKey');
    //     }
    //     return () => validationService.cleanValidation('sshPasswordlessKey');
    // }, [value, anotherSectionActive])

    return (
        <div className="form-group">
            <div className="oct_form-group oct_passwordless_key">
                <div className="modal-v2-field-label-row">
                    <label htmlFor="ssh_passwordless-key">Passwordless Key</label>
                    {showChangeBtn
                        && value
                        && <button type="button"
                            className="modal-v2-inline-change-btn"
                            onClick={!disableInput ? null : () => onChangePasswordClick()}>
                            Change
                        </button>}
                </div>
                <textarea className={`form-control oct_field ${error && 'border-danger'}`}
                    id="ssh_passwordless-key"
                    value={centralCredentialId ? '' : value}
                    disabled={disableInput}
                    onChange={disableInput ? null : event => onChange(event.target.value)} />
            </div>
        </div>
    )
}

function mapStateToProps(state) {
    debug("SshPasswordlessKeyField mapStateToProps", state);
    const validation = state.validation;
    return {
        error: validation.sshPasswordlessKey,
    }
}

export default connect(mapStateToProps)(SshPasswordlessKeyField);
